import React, { useEffect, useState } from "react";
import { makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import NoData from "../../utils/DataNotFound";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import profile from "../../assets/img/profile.jpg";

export default function AllAdmins() {
  const currentAdmin = JSON.parse(sessionStorage.getItem("user")) || {};
  const isAdmin = currentAdmin?.role === "admin";

  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const pageSize = 10;

  const [filters, setFilters] = useState({
    keyword: "",
    fromDate: "",
    toDate: "",
    roleType: "",
    sortBy: "createdAt",
    sortOrder: "desc",
  });

  const U = (v) => v ? v : "N/A";

  const fetchUsers = async () => {
    try {
      const payload = {
        keyWord: filters.keyword,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
        pageNo,
        size: pageSize,
      };

      if (isAdmin && filters.roleType) {
        payload.roleType = filters.roleType;
      }

      const response = await makeRequestAuth(
        "post",
        "/admin/adminListing",
        payload
      );

      setUsers(response?.data?.list || []);
      setTotalUsers(response?.data?.total || 0);
    } catch (error) {
      console.log("Error Fetching Users:", error);
    }
  };

  useEffect(() => {
    setPageNo(1);
  }, [
    filters.keyword,
    filters.status,
    filters.sortBy,
    filters.sortOrder,
  ]);

  useEffect(() => {
    fetchUsers();
  }, [pageNo, filters]);


  const handleStatusChange = async (id) => {
    try {
      const response = await makeRequestAuth(
        "post",
        "/admin/adminStatustoggel",
        {
          id
        }
      );

      const resData = response?.data;

      if (resData?.error) {
        showErrorToast(resData?.error || "Something went wrong");
        return;
      }

      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user._id === id
            ? { ...user, isDisable: !user.isDisable }
            : user
        )
      );
      showSuccessToast("admin status updated successfully!");

    } catch (error) {
      console.error("Error updating admin status:", error);

      const errorMessage = error?.message ||
        "Failed to update admin status. Please try again later.";

      showErrorToast(errorMessage);
    }
  };

  const TEAM_TYPES = {
    property_team: "Property Team",
    services_team: "Services Team",
    loan_team: "Loan Team",
    support_team: "Support Team",
  };


  const totalPages = Math.ceil(totalUsers / pageSize);
  return (
    <div>
      <ToastContainer />
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-800">
          Admin Mennagement
        </h2>

        <button
          onClick={() => navigate("/save-admin")}
          className="px-5 py-2.5 bg-[#24ADD7] text-white rounded-lg font-semibold shadow hover:bg-[#106D87] transition"
        >
          ➕ Create New Admin
        </button>
      </div>


      {/* FILTERS */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">

        <input
          type="text"
          placeholder="Search..."
          className={`border p-2 rounded w-full ${filters.keyword ? "border-[#24ADD7] shadow-sm" : ""
            }`}
          value={filters.keyword}
          onChange={(e) =>
            setFilters({ ...filters, keyword: e.target.value })
          }
        />

        {/* ROLE TYPE FILTER – ONLY FOR ADMIN */}
        {isAdmin && (
          <select
            className={`border p-2 rounded w-full ${filters.roleType ? "border-[#24ADD7] shadow-sm" : ""
              }`}
            value={filters.roleType || ""}
            onChange={(e) =>
              setFilters({ ...filters, roleType: e.target.value })
            }
          >
            <option value="">All Roles</option>
            <option value="property_team">Property Team</option>
            <option value="services_team">Services Team</option>
            <option value="loan_team">Loan Team</option>
            <option value="support_team">Support Team</option>
          </select>
        )}


        <select
          className={`border p-2 rounded w-full ${filters.status ? "border-[##24ADD7] shadow-sm" : ""
            }`}
          value={filters.status}
          onChange={(e) =>
            setFilters({ ...filters, status: e.target.value })
          }
        >
          <option value="">All Status</option>
          <option value="false">Active</option>
          <option value="true">Inactive</option>
        </select>
      </div>

      {/* SORTING */}
      <div className="flex items-center gap-4 mb-5">
        <select
          className={`border p-2 rounded ${filters.sortBy !== "" ? "border-[##24ADD7]" : ""
            }`}
          value={filters.sortBy}
          onChange={(e) => setFilters({ ...filters, sortBy: e.target.value })}
        >
          <option value="createdAt">Created At</option>
          <option value="name">Name</option>
          <option value="email">Email</option>
        </select>

        <select
          className={`border p-2 rounded ${filters.sortOrder !== "" ? "border-[##24ADD7]" : ""
            }`}
          value={filters.sortOrder}
          onChange={(e) =>
            setFilters({ ...filters, sortOrder: e.target.value })
          }
        >
          <option value="desc">Descending</option>
          <option value="asc">Ascending</option>
        </select>

      </div>

      {/* TABLE */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-200 text-left">
              <th className="p-3">SR No.</th>
              <th className="p-3">Image</th>
              <th className="p-3">Name</th>
              <th className="p-3">Email</th>
              <th className="p-3">Mobile</th>
              <th className="p-3">Role</th>
              <th className="p-3">Is Team Leader</th>
              <th className="p-3">Status</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="7">
                  <NoData title="User Not Found!" />
                </td>
              </tr>
            ) : (
              users.map((user, index) => (
                <React.Fragment key={user._id}>
                  <tr className="border-b">
                    <td className="p-3">
                      {(pageNo - 1) * pageSize + index + 1}
                    </td>


                    <td className="p-3">
                      <img
                        src={user.image || profile}
                        alt="user"
                        className="h-12 w-12 rounded-full object-cover border"
                      />
                    </td>

                    <td className="p-3">{U(user.userName)}</td>
                    <td className="p-3">{U(user.email)}</td>
                    <td className="p-3">{U(user.phone)}</td>
                    <td className="p-3">{U(TEAM_TYPES[user.role])}</td>
                    <td className="p-3">{user.teamLeader ? 'Yes' : "No"}</td>

                    <td className="p-3">
                      <span
                        className={`px-3 py-1 rounded text-white ${user.isDisable === false
                          ? "bg-green-600"
                          : "bg-red-600"
                          }`}
                      >
                        {user.isDisable === false ? "Active" : "Inactive"}
                      </span>
                    </td>

                    <td className="p-3">
                      <select
                        value={String(user.isDisable)}
                        onChange={(e) =>
                          handleStatusChange(user._id, e.target.value)
                        }
                        className={`mt-2 px-4 py-1 rounded-md border text-sm font-semibold focus:outline-none ${user.isDisable === false
                          ? "bg-green-50 border-green-500 text-green-600"
                          : "bg-red-50 border-red-500 text-red-600"
                          }`}
                      >
                        <option value="false">Active</option>
                        <option value="true">Inactive</option>
                      </select>
                    </td>
                  </tr>
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="flex justify-end mt-4 items-center gap-4">
        <button
          disabled={pageNo <= 1}
          onClick={() => setPageNo(pageNo - 1)}
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Prev
        </button>

        <span>
          Page {pageNo} / {Math.ceil(totalUsers / pageSize)}
        </span>


        <button
          disabled={pageNo >= totalPages}
          onClick={() => setPageNo(pageNo + 1)}
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div >
  );
}